module.exports = __webpack_public_path__ + "img/left-platinum.57669d9.jpg";